import React from "react";

export const Loader: React.FC<any> = (props) => {
  return <div className="loader">
    <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
  </div>
}